import { EventResponse } from '@goldcast/api/backend';

import { State } from './types';

const getters = {
  getSeriesEvents(state: State): Array<EventResponse> {
    return Object.values(state.filteredEvents);
  },
  getSeriesOnDemandEventIds(state: State): string[] {
    return state.onDemandEventIds;
  },
  getSeriesEventById: (state: State) => (eventId: string) => {
    return state.filteredEvents[eventId];
  },
  getEvent: (state: State) => (eventId: string) => {
    return state.events[eventId];
  },
  getEvents: (state: State) => {
    return Object.values(state.events);
  }
};

export default getters;
